import { useState, useEffect } from 'react';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import FleetPage from './FleetPage';
import axios from 'axios';
import { Wrench } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AtelierFleetPage = () => {
  const { token } = useAdminAuth();
  const [atelierOrgId, setAtelierOrgId] = useState(null);
  const [atelierOrgName, setAtelierOrgName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initAtelierOrg = async () => {
      try {
        // First check if sub-org exists
        const checkRes = await axios.get(`${API_URL}/api/saas/atelier-sub-org`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (checkRes.data.exists) {
          setAtelierOrgId(checkRes.data.atelier_org.id);
          setAtelierOrgName(checkRes.data.atelier_org.name);
        } else {
          // Create it
          const initRes = await axios.post(`${API_URL}/api/saas/atelier-sub-org/init`, {}, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (initRes.data.success) {
            setAtelierOrgId(initRes.data.atelier_org.id);
            setAtelierOrgName(initRes.data.atelier_org.name);
          }
        }
      } catch (err) {
        setError(err.response?.data?.detail || 'Erreur lors de l\'initialisation');
      }
      setLoading(false);
    };
    if (token) initAtelierOrg();
  }, [token]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-3 border-amber-500/30 border-t-amber-500 rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6 text-center">
        <p className="text-red-400">{error}</p>
      </div>
    );
  }

  return (
    <div data-testid="atelier-fleet-page">
      {/* Atelier badge */}
      <div className="bg-purple-500/10 border-b border-purple-500/20 px-4 py-2 flex items-center gap-2">
        <Wrench size={16} className="text-purple-400" />
        <span className="text-sm text-purple-300 font-medium">{atelierOrgName}</span>
        <span className="text-xs text-purple-400/60">— Flotte Atelier</span>
      </div>
      <FleetPage token={token} mode="admin" atelierOrgId={atelierOrgId} />
    </div>
  );
};

export default AtelierFleetPage;
